import { showPhase } from "./phase";
import { handleFacebookPixel } from "../trackers/facebook";
import { submit3D } from "../forms/3d";
import { handlePrecondition } from "./preconditonHandler";
import { createAndSendForm, createIFrameAndResolveMessage } from "./iframe";
import { FORM_INPUTS } from "./formInputs";
import { isFullDataForm } from "../main";
import { createPopupMessage } from "./popup";
import { getPageLang } from "./lang";
import { initSecure3d, SECURE_3D } from "./secure";
import { generateOrderDTO } from "./order";
import {isRetryingPayment} from "./retryingPayment";

export const handleResponse = (response) => {
    if (response.readyState === 4) {
        if (response.status === 200) {
            const json = JSON.parse(response.responseText);
            if (json.status === 'SUCCESSFUL') {
                showPhase('Success');
                if (json.firePixel === true) {
                    handleFacebookPixel();
                }
            } else if (json.status === 'PENDING') {

                if (json.gateway === "NET_VALVE") {
                    const { threeDSResponse } = JSON.parse(response.responseText);

                    const transactionId = threeDSResponse.transactionId;
                    const url = threeDSResponse.url;
                    const isHidden = threeDSResponse.hidden;

                    createIFrameAndResolveMessage(url, isHidden).then(res => {
                        submit3D(transactionId, res)
                    });

                    return;
                }

                if (json.gateway === "BILL_1ST") {
                    const { threeDSResponse } = JSON.parse(response.responseText);

                    const merchantCode = threeDSResponse.merchantCode;
                    const jwt = threeDSResponse.jwt;
                    const transactionId = threeDSResponse.transactionId;
                    const amount = threeDSResponse.amount;
                    const currencyNumericCode = threeDSResponse.currencyNumericCode;
                    const force = threeDSResponse.force;

                    if (!SECURE_3D) {
                        initSecure3d(merchantCode, jwt)

                        SECURE_3D.on('payments.initialSetup', function (data) {
                            console.log('payments.initialSetup');
                        });

                        SECURE_3D.on('payments.setupComplete', function (data) {
                            console.log('payments.setupComplete');
                            try {
                                console.log('generateOrderDTO: ', generateOrderDTO(amount, currencyNumericCode));
                                SECURE_3D.do3D(generateOrderDTO(amount, currencyNumericCode));
                            } catch (error) {
                                console.log('payments.setupComplete error');
                                showPhase('Error');
                            }
                        });

                        SECURE_3D.on('payments.errorSetup', function (data) {
                            console.log('payments.errorSetup')
                            showPhase('Error');
                        });

                        SECURE_3D.on('transaction.complete', function (data) {
                            console.log('transaction.complete');
                        });
                    }

                    SECURE_3D.on('payments.validated', function (data, jwt, callback) {
                        console.log('payments.validated');
                        console.log(data);
                        submit3D(transactionId, data);
                    });

                    SECURE_3D.on('payments.noAction', function (data) {
                        console.log('payments.noAction');
                        console.log(data);
                        submit3D(transactionId, data);
                    });

                    if (force) {
                        SECURE_3D.forceAuthentication(generateOrderDTO(amount, currencyNumericCode));

                        return;
                    }

                    if (isRetryingPayment && SECURE_3D) {
                        SECURE_3D.do3D(generateOrderDTO(amount, currencyNumericCode));
                    }

                    return;
                }

                const { threeDSResponse } = JSON.parse(response.responseText);

                const threeDUrl = threeDSResponse.url;
                const preconditions = threeDSResponse.preconditions;
                const threeDUrlParams = threeDSResponse.params;

                if (threeDUrl != null && preconditions && preconditions.length) {
                    Promise.all(
                        preconditions.map((precondition, index) =>
                            handlePrecondition({
                                index,
                                ...precondition
                            }),
                        ),
                    )
                        .then(() => {
                            createAndSendForm(threeDUrl, threeDUrlParams);
                        })
                        .catch(() => {
                            showPhase('Error');
                        });
                } else if (threeDUrl != null) {
                    createAndSendForm(threeDUrl, threeDUrlParams);
                } else {
                    showPhase('Error');
                }
            } else {
                showPhase('Error');
                console.log(response.status);
            }
        }
        else if (response.status === 400) {
            const json = JSON.parse(response.responseText);

            if (json.status === 'FAILED' && json.message === 'Invalid email address') {
                isFullDataForm ? showPhase('Oneform') : showPhase('UserData');

                FORM_INPUTS.email.element.classList.remove('valid');
                FORM_INPUTS.email.element.classList.add('invalid');

                createPopupMessage('invalid-email')
                doTranslation(getPageLang(), 'lng-tag');

                return
            }

            showPhase('Error');
        } else {
            showPhase('Error');
        }
    }
};